import OrderlikeLayout from '../../../../../../generic/Layouts/OrderlikeLayout'
import TitlesList from '../../../../../../generic/titlesRowItem/TitlesList'
import PalletItem from './PalletItem'
import ControlSearchPannelLayout from '../../../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import ScanInput from '../../../kosherTeudot/Components/ScanInput'
import useScannedDataHandler from '../../../kosherTeudot/Hooks/useScannedDataHandler'
import styled from 'styled-components'
import useKavPalletService from '../services/useKavPalletService'
import ControlButton from '../../../../../../generic/buttons/ControlButton'
import TabIcons from './TabIcons'

interface Props {
    date: Date,
}
const PalletsSection = ({date}: Props) => {
    const {
        id,
        TAB_LIST,
        activeTab,
        handleSelectTab,
        inputRef,
        searchValue,
        setSearchValue,
        handleScan,
        handleFinish,
        isReadyToFinish,
        putPalletStatus,
        render
    } = useKavPalletService(date)
    useScannedDataHandler(inputRef, handleScan)
  return (
    <OrderlikeLayout
        label={`העמסת משטחים - קו ${id}`}
    >
        <ControlSearchPannelLayout>
            
            <ScanInput
                ref={inputRef}
                input={searchValue}
                setInput={setSearchValue}
                enterFunc={handleScan}
            />
        </ControlSearchPannelLayout>
        <Container>
            <TabContainer>
                {TAB_LIST.map((type, index) => (
                    <Tab
                        key={index}
                        $active={activeTab === type}
                        onClick={() => handleSelectTab(type)}
                    >
                        {
                            type === TAB_LIST[0] ? (
                                <TabIcons status={7} />
                            )
                            :
                            type === TAB_LIST[1] ? (
                                <TabIcons status={0} color='tomato' />
                            )
                            :
                            type.name
                        }
                    </Tab>
                ))}
            </TabContainer>
            <TitlesList
                list={render}
                uniqueKey={'Pallet_Num'}
                noPadding={false}
                Element={PalletItem}
                additionalData={{
                    putPalletStatus
                }}
                borderLess
            />
        </Container>
        {
            isReadyToFinish && (
                <ControlButton
                    lable='סיים העמסה'
                    handleClick={handleFinish}
                />
            )
        }
        
    </OrderlikeLayout>
  )
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1;
`

const TabContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  background: #eff3f4;
  border-radius: 30px 30px 0 0;
`

const Tab = styled.div<{ $active: boolean }>`
  padding: 8px 16px;
  color: #838484;
  width: 7em;
  border-radius: 30px 30px 0 0;
  cursor: pointer;
  ${(props) =>
    props.$active
      ? `
                background: #fff;
                border-bottom: none;
                color: #7ab0ab;
            `
      : `
            
            `}
`
export default PalletsSection